import * as React from 'react'
import DangerouslySetInnerHtml from '../../../shared/components/dangerouslySetInnerHtml'

import { Props } from '../../containers/landingPageContainer'

const LandingPage = ({ html, css }: Props) => {
  return (
    <div className="landing-page-content">
      {css && <style>{css}</style>}
      <DangerouslySetInnerHtml className="landing-page-body">
        {html}
      </DangerouslySetInnerHtml>
    </div>
  )
}

export default LandingPage
